import React from 'react';
import {Dialog, DialogTitle, DialogContent, Typography, Button} from '@mui/material'
import {Close} from '@mui/icons-material'

export default function Popup(props){

  const {title, children, openPopup, setOpenPopup} = props;

  return(
    <Dialog open={openPopup} onClose={() => setOpenPopup(false)} maxWidth="mx">
        <DialogTitle>
            <div style={{display: 'flex'}}>
              <Typography variant="h6" comonent="div" style={{flexGrow: 1}}>
                {title}
              </Typography>
              <Button color="error" onClick={() => setOpenPopup(false)}><Close/></Button>
            </div>
        </DialogTitle>
        <DialogContent dividers>
          {children}
        </DialogContent>
    </Dialog>
  )
}
